var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPauseControls = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.77 17.77",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pause") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.88,
    cy: 8.88,
    r: 8.88
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7881",
    "data-name": "Rectangle 7881",
    className: "cls-1",
    x: 5.88,
    y: 5.88,
    width: 2,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7882",
    "data-name": "Rectangle 7882",
    className: "cls-1",
    x: 9.88,
    y: 5.88,
    width: 2,
    height: 6
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPauseControls);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNy43NyAxNy43NyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5QYXVzZTwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48Y2lyY2xlIGN4PSI4Ljg4IiBjeT0iOC44OCIgcj0iOC44OCIvPjxyZWN0IGlkPSJSZWN0YW5nbGVfNzg4MSIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNzg4MSIgY2xhc3M9ImNscy0xIiB4PSI1Ljg4IiB5PSI1Ljg4IiB3aWR0aD0iMiIgaGVpZ2h0PSI2Ii8+PHJlY3QgaWQ9IlJlY3RhbmdsZV83ODgyIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA3ODgyIiBjbGFzcz0iY2xzLTEiIHg9IjkuODgiIHk9IjUuODgiIHdpZHRoPSIyIiBoZWlnaHQ9IjYiLz48L2c+PC9nPjwvc3ZnPg==";